export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://mobapi.bayalarmmedical.com/';
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || '$2a$10$e.oPc.dyrwRoQCpDvO9Rhe';
export const API_VERSION = process.env.REACT_APP_API_VERSION || '25.0';
export const APP = process.env.REACT_APP_NAME || 'bam';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://bam-api-socket.bayalarmmedical.com/';
